export const STANDARD_PAGE = "standard-page ";
export const LANDING_PAGE = "landing-page";
export const LISTING_PAGE = "listing-page";
export const BLOG_POST = "blog-post";
export const KNOWLEDGE_ARTICLE = "knowledge-article";
